export class AppError {
	/**
	 *
	 */
	constructor(public originalError?: any) {}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/common/app-error.ts